export default "__VITE_ASSET__b73bca65__"